import React, { useEffect, useState } from "react";
import commitmentSlice from "../../../state/slices/commitmentSlice";
import validatorSlice from "../../../state/slices/validatorSlice";
import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { getCommitmentTypeId } from "../helpers/Categories";
import translate from "../../reusable/translate";
import Meter from "../meter/Meter";
import OperationDescription from "./OperationDescription";
import Tooltip from "../tooltip/Tooltip";

const Operation = ({
  index,
  operation,
  greenDealOperations,
  meterRef,
  hundredToDoMeters,
}) => {
  const dispatch = useDispatch();
  const [theme, setTheme] = useState("");
  const [loading, setLoading] = useState(true);
  const [collapsed, setCollapsed] = useState(false);
  const [ownOperation, setOwnOperation] = useState(false);
  const [selectedOperation, setSelectedOperation] = useState({
    id: "",
    meters: [],
  });
  const { language, commitment, validators } = useSelector((state) => state);
  const [privateOperation, setPrivateOperation] = useState(
    operation.privateOperation || false
  );
  const { changeMeterValidator } = bindActionCreators(
    validatorSlice.actions,
    dispatch
  );

  const {
    addMeter,
    deleteMeter,
    deleteOperation,
    changeOperationTitle,
    changeOperationPrivacy,
  } = bindActionCreators(commitmentSlice.actions, dispatch);

  const removeMeter = (meterId) => {
    deleteMeter({
      operationId: operation.operationId,
      meterId: meterId,
    });
  };

  const addNewMeter = () => {
    addMeter({
      meter: {
        meterId: uuidv4(),
        meterType_fi_FI: "",
        meterType_en_US: "",
        meterType_sv_SE: "",
        meterValueType: "",
        startingLevel: "",
        targetLevel: "",
        meterChartType: "",
        isNew: true,
      },
      operationId: operation.operationId,
    });
  };

  const removeOperation = () => {
    deleteOperation(operation);
  };

  const setOperationTitle = (title) => {
    changeOperationTitle({
      operationId: operation.operationId,
      language: language,
      title: title,
    });
  };

  const setGreenDealOperation = (id) => {
    const greenDealOperation = greenDealOperations.find(
      (mappedOperation) => mappedOperation.id === id
    );

    if (greenDealOperation) {
        console.log("Operations found")
      setSelectedOperation(greenDealOperation);
    }
  };

  useEffect(() => {
    console.log(greenDealOperations)

    if (operation[`operationTitle_${language}`] !== "") {
      const greenDealOperation = greenDealOperations.find(
        mappedOperation =>
          mappedOperation[`operationTitle_${language}`] ===
          operation[`operationTitle_${language}`]
      );
      if (greenDealOperation) {
        console.log(greenDealOperation)
        setSelectedOperation(greenDealOperation);
        setOwnOperation(false);
      } else {
        setOwnOperation(true);
      }
    }
    if (
      hundredToDoMeters &&
      (!selectedOperation.id || selectedOperation.id === "")
    ) {
      setSelectedOperation({ ...operation, meters: hundredToDoMeters });
    }
    setLoading(false);
  }, [greenDealOperations]);

  useEffect(() => {
    if (selectedOperation) {
      const greenDealOperation = greenDealOperations.find(
        (mappedOperation) => mappedOperation.id === selectedOperation.id
      );
      if (greenDealOperation) {
        changeOperationTitle({
          operationId: operation.operationId,
          language: "fi_FI",
          title: greenDealOperation.operationTitle_fi_FI,
        });
        changeOperationTitle({
          operationId: operation.operationId,
          language: "sv_SE",
          title: greenDealOperation.operationTitle_sv_SE,
        });
        changeOperationTitle({
          operationId: operation.operationId,
          language: "en_US",
          title: greenDealOperation.operationTitle_en_US,
        });
      }
    }
  }, [selectedOperation]);

  useEffect(() => {
    changeOperationPrivacy({
      operation: operation,
      privacy: privateOperation,
    });
  }, [privateOperation]);

  if (loading) return null;

  return (
    <div
      className={`${
        validators.operations
          ? "operation margin-top-bot"
          : "operation-validated margin-top-bot"
      }`}
    >
      <OperationHeaderDisplay
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        operation={operation}
        removeOperation={removeOperation}
        language={language}
      />

      {!collapsed && (
        <div>
          <div className="border-bottom">
            {commitment.commitmentType === "MATERIAL" && (
              <OperationThemeContainer
                operation={operation}
                theme={theme}
                setTheme={setTheme}
              />
            )}

            {ownOperation && (
              <OwnOperationContainer
                index={index}
                setOwnOperation={setOwnOperation}
                language={language}
                operation={operation}
                setOperationTitle={setOperationTitle}
                theme={theme}
                commitment={commitment}
              />
            )}

            {!ownOperation && (
              <ChooseOperationContainer
                index={index}
                operation={operation}
                greenDealOperations={greenDealOperations}
                setGreenDealOperation={setGreenDealOperation}
                setOwnOperation={setOwnOperation}
                meterRef={meterRef}
                selectedOperation={selectedOperation}
                theme={theme}
              />
            )}

            {commitment.commitmentType === "MATERIAL" && (
              <OperationDescription
                operation={operation}
                title={"sit.commitment.operations.operationDescription"}
                maxLength={3500}
                language={language}
              />
            )}

            {((selectedOperation && selectedOperation.id) || ownOperation) &&
              (selectedOperation.allowToSelectPublicity ||
                commitment.allowToSelectPublicity) && (
                <PublicitySelectionContainer
                  operation={operation}
                  privateOperation={privateOperation}
                  setPrivateOperation={setPrivateOperation}
                />
              )}
          </div>

          {operation.meters.map((meter, meterIndex) => (
            <Meter
              operationMeterId={`operation-${index}_meter-${meterIndex}`}
              operation={operation}
              meter={meter}
              key={meter.meterId}
              index={index}
              removeMeter={removeMeter}
              selectedOperation={selectedOperation}
              disabled={operation.published && !meter.isNew}
            />
          ))}

          {selectedOperation.meters.length > 0 && (
            <button
              className={`add-meter-button items-center margin-top-bot ${
                validators.meter ? "" : "add-meter-button-validated"
              }`}
              //disabled={operation.published}
              onClick={() => {
                changeMeterValidator(true);
                addNewMeter();
              }}
            >
              {translate({ textKey: "sit.commitmentCreation.addMeter" })}{" "}
              <i className="fas fa-plus-circle" />
            </button>
          )}

          {!selectedOperation.meters.length && (
            <div>
              <button
                className="add-meter-button items-center margin-top-bot"
                onClick={() => addNewMeter()}
              >
                {translate({ textKey: "sit.commitmentCreation.addMeter" })}{" "}
                <i className="fas fa-plus-circle" />
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Operation;

const OperationHeaderDisplay = ({
  collapsed,
  setCollapsed,
  operation,
  removeOperation,
  language,
}) => {
  return (
    <div
      className="flex-row space-between items-center operation-header section"
      onClick={() => setCollapsed(!collapsed)}
    >
      <div key={collapsed} className="flex-row items-center w800">
        <i
          className={`fas ${collapsed ? "fa-chevron-up" : "fa-chevron-down"}`}
        />
        <h4>
          {operation["operationTitle_" + language] ||
            translate({ textKey: "sit.commitmentCreation.operation" })}
        </h4>
      </div>
      <button
        className="green-button w200"
        onClick={() => removeOperation(operation.operationId)}
        disabled={operation.published}
      >
        {translate({ textKey: "sit.commitment.operations.removeOperation" })}
        <i className="fas fa-trash" />
      </button>
    </div>
  );
};

const OwnOperationContainer = ({
  index,
  operation,
  setOperationTitle,
  language,
  setOwnOperation,
  theme,
  commitment,
}) => {
  return (
    <div className="flex-row items-center margin-top-bot">
      <div className="w200 flex-row">
        <p className="p">
          {translate({ textKey: "sit.commitmentCreation.operationName" })}
        </p>
        <Tooltip
          textKey={`sit.commitmentCreation.operationNameInfo.${commitment.commitmentSubcategoryId}`}
          secondaryTextKey={"sit.commitmentCreation.operationNameInfo"}
        />
      </div>
      <div className="w800 space-between">
        <input

          className="input-text"
          onChange={(e) => {
            if (e.target.value.length >= 1) setOperationTitle(e.target.value);
          }}
          value={operation["operationTitle_" + language] || theme}
          type="text"
          placeholder="Syötä toimenpiteen nimi"
          disabled={operation.published}
        />
        <button
          className="green-button"
          onClick={() => setOwnOperation(false)}
          disabled={operation.published}
        >
          {translate({
            textKey: "sit.commitmentCreation.choosePredefinedOperation",
          })}
        </button>
      </div>
    </div>
  );
};

const ChooseOperationContainer = ({
  index,
  meterRef,
  setGreenDealOperation,
  greenDealOperations,
  setOwnOperation,
  operation,
  selectedOperation,
  theme,
}) => {
  const { commitment, validators, language } = useSelector((state) => state);
  const dispatch = useDispatch();
  const { changeMeterValidator } = bindActionCreators(
    validatorSlice.actions,
    dispatch
  );

  return (
    <div className="flex-row items-center margin-top-bot ">
      <div className="w200">
        <div className="flex-row items-center">
          <p className="p">
            {translate({ textKey: "sit.commitmentCreation.chooseOperation" })}
          </p>
          <Tooltip
            textKey={`tooltip.chooseOperation.${commitment.commitmentSubcategoryId}`}
            secondaryTextKey={`tooltip.chooseOperation.${commitment.commitmentCategoryId}`}
            fallback={`tooltip.chooseOperation.general`}
          />
        </div>
      </div>
      <div className="w800 space-between" ref={meterRef}>
        <select
          id={`operationSelector-${index}`} 
          className={`select ${validators.meter ? "" : "select-validated"}`}
          onChange={(e) => {
            console.log(e.target.value)
            setGreenDealOperation(e.target.value);
            changeMeterValidator(true);
          }}
          value={selectedOperation.id || operation.operationId}
          disabled={
            operation.published ||
            (commitment.commitmentType === "MATERIAL" && !theme)
          }
        >
          <option value="">
            {translate({ textKey: "sit.commitmentCreation.chooseOperation" })}
          </option>
          {greenDealOperations
            .sort((a, b) =>
              a.operationTitle_fi_FI.localeCompare(
                b.operationTitle_fi_FI,
                undefined,
                { numeric: true }
              )
            )
            .filter((mappedOperation) =>
              mappedOperation.operationTitle_fi_FI.startsWith(theme)
            )
            .map((mappedOperation) => {
                // console.log(mappedOperation.operationTitle_fi_FI)
                return (
                    <option
                      key={mappedOperation.operationTitle_fi_FI}
                      value={mappedOperation.id}
                    >
                      {mappedOperation["operationTitle_" + language]}
                    </option>
                  )
            })}
        </select>

        <button
          className="green-button"
          onClick={() => setOwnOperation(true)}
          disabled={
            operation.published ||
            (commitment.commitmentType === "MATERIAL" && !theme)
          }
        >
          {translate({ textKey: "sit.commitmentCreation.createOwnOperation" })}
        </button>
      </div>
    </div>
  );
};

const OperationThemeContainer = ({ operation, setTheme, theme }) => {
  const findOperationTheme = () => {
    if (operation.operationTitle_fi_FI && !theme) {
      return operation.operationTitle_fi_FI.split(".")[0] + ".";
    }
    return "";
  };

  return (
    <div className="flex-row items-center margin-top-bot">
      <div className="flex-row items-center w200">
        <p className="p">
          {translate({ textKey: "sit.commitment.operations.operationTheme" })}
        </p>
        <Tooltip textKey={"sit.commitmentCreation.operationMatsitTypeInfo"} />
      </div>
      <div className="w800 space-between">
        <select
          className={"select"}
          onChange={(e) => setTheme(e.target.value)}
          disabled={operation.published}
          defaultValue={findOperationTheme()}
        >
          <option value="" key={"def"}>
            Valitse toimenpidetyyppi...
          </option>
          <option value="1.">
            1. Prosessien materiaalitehokkuuden parantaminen
          </option>
          <option value="2.">
            2. Ruokahävikin vähentäminen (toimitusketjussa)
          </option>
          <option value="3.">3. Pakkausten materiaalitehokkuus</option>
          <option value="4.">4. Kierrätyksen lisääminen</option>
          <option value="5.">5. Non-food-tuotteiden materiaalivalinnat</option>
          <option value="6.">6. Pakkausten materiaalivalinnat</option>
          <option value="7.">7. Arvoketjuyhteistyön parantaminen</option>
          <option value="8.">
            8. Henkilöstön kouluttaminen materiaalitehokkuuden parantamisesta
          </option>
          <option value="9.">
            9. Kuluttajaneuvonta tuotteisiin liittyvistä ympäristö- ja
            ilmastovaikutuksista
          </option>
          <option value="10.">
            10. Kuluttajaviestinnän lisääminen ruokahävikin vähentämisen
            keinoista
          </option>
          <option value="11.">
            11. Materiaalitehokkuuden parantamismahdollisuuksien tunnistaminen
          </option>
          <option value="12.">12. Pakkausmerkintöjen parantaminen</option>
          <option value="13.">
            13. Muovisten kertakäyttöpakkausten green deal
          </option>
          <option value="14.">14. Muu</option>
        </select>
      </div>
    </div>
  );
};

const PublicitySelectionContainer = ({
  privateOperation,
  operation,
  setPrivateOperation,
}) => {
  return (
    <div className="grid28">
      <div className="flex-row">
        <p className="p">
          {translate({ textKey: "sit.commitmentCreation.operationIs" })}
        </p>
        <Tooltip textKey={"sit.commitmentCreation.operationPublicityInfo"} />
      </div>
      <div>
        <div className="flex-row items-center">
          <input
            className="input-radio"
            type="radio"
            name={`publicity.${operation.operationId}`}
            onClick={() => setPrivateOperation(false)}
            defaultChecked={!privateOperation}
            disabled={operation.published}
          />
          <p className="p">
            {translate({
              textKey: "sit.commitmentCreation.public",
            })}
          </p>
        </div>
        <div className="flex-row items-center">
          <input
            className="input-radio"
            type="radio"
            name={`publicity.${operation.operationId}`}
            onClick={() => setPrivateOperation(true)}
            defaultChecked={privateOperation}
            disabled={operation.published}
          />
          <p className="p">
            {translate({
              textKey: "sit.commitmentCreation.private",
            })}
          </p>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/materialCommitment/operation/Operation.jsx